/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_ReleasesInputs */

const en_gc_resources_download_releases = /** @type {(inputs: Gc_Resources_Download_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All releases and other architectures`)
};

const zh_gc_resources_download_releases = /** @type {(inputs: Gc_Resources_Download_ReleasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部版本与其他架构`)
};

/**
* | output |
* | --- |
* | "All releases and other architectures" |
*
* @param {Gc_Resources_Download_ReleasesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_releases = /** @type {((inputs?: Gc_Resources_Download_ReleasesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_ReleasesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_releases(inputs)
	return zh_gc_resources_download_releases(inputs)
});
export { gc_resources_download_releases as "gc.resources.download.releases" }